import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery'
export const ASSET_CLASSES_API_REDUCER_KEY = 'assetClassesApi';


export const assetClassesApi = createApi({
    reducerPath: ASSET_CLASSES_API_REDUCER_KEY,
    baseQuery: apiBaseQuery,
    tagTypes: ['assetClasses'],
    endpoints: (builder) => ({
        getAllAssetClasses: builder.query({
            query: ({ page, q, limit }) => ({
                url: `admin/repository/asset-classes?page=${page}&q=${q}&limit=${limit}`
            }),
            providesTags: ['assetClasses']
        }),
        getAssetClass: builder.query({
            query: (id) => ({
                url: `admin/repository/asset-classes/${id}`
            }),
            providesTags: ['assetClasses']
        }),
        createAssetClass: builder.mutation({
            query: (body) => ({
                url: `admin/repository/asset-classes/`,
                method: 'POST',
                body
            }),
            invalidatesTags: ['assetClasses']
        }),
        updateAssetClass: builder.mutation({
            query: ({ id, ...rest }) => ({
                url: `admin/repository/asset-classes/${id}`,
                method: 'PUT',
                body: rest
            }),
            invalidatesTags: ['assetClasses']
        }),
    })
});

export const {
    useGetAllAssetClassesQuery,
    useGetAssetClassQuery,
    useCreateAssetClassMutation,
    useUpdateAssetClassMutation
} = assetClassesApi;